import React from 'react';

export const LeftTitle = ({ title, subtitle, subcolor }) => {
  return (
    <div className="titleRow text-left">
      <h2 className="text-neutralSecondary ">
        <span className="subcolor-darker">{subcolor}</span>
        {title}
      </h2>
      <h5 className="pt-3 text-uppercase">{subtitle}</h5>
    </div>
  );
};

export const CenterTitle = ({ title, subtitle, subcolor }) => {
  return (
    <div className="pb-5 mx-auto text-center">
      <h2 className="text-neutralSecondary">
        <span className="subcolor-darker">{subcolor}</span>
        {title}
      </h2>
      <h5 className="text-capitalize text-black-50">{subtitle}</h5>
    </div>
  );
};

export const LinkTitle = ({ title, subtitle, url }) => {
  return (
    <a href={url} className="link-title">
      <h4>{title}</h4>
      <h5 className="text-black-50">{subtitle}</h5>
    </a>
  );
};

export const JobTitle = ({ title, subtitle}) => {
  return (
    <div className="job-title">
      <h4>{title}</h4>
      <small className="font-weight-bold text-primary text-uppercase">{subtitle}</small>
    </div>
  );
};